var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex flex-column flex primary-gradient-bg-light-inverted",attrs:{"outlined":""}},[_c('IncomingMatchesTable',{staticClass:"d-flex flex-column flex"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }